/**
 * Map audit action codes (machine-readable) to Hebrew display labels.
 * Unknown actions fall back to the raw action string.
 */

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  // Auth events (client-driven via logAudit)
  'auth.signed_in': 'התחברות',
  'auth.signed_up': 'יצירת חשבון',
  'auth.signed_out': 'התנתקות',
  'auth.email_verified': 'אימות מייל',
  'auth.password_reset_requested': 'בקשת איפוס סיסמה',
  'auth.password_reset_completed': 'איפוס סיסמה',

  // Org lifecycle (Edge Function + DB triggers)
  'org.bootstrapped': 'יצירת עסק',
  'organizations.updated': 'עדכון פרטי עסק',
  'organizations.deleted': 'מחיקת עסק',

  // Profile (DB trigger)
  'user_profiles.updated': 'עדכון פרופיל',

  // Team (DB trigger from 0001)
  'team_members.created': 'הוספת חבר צוות',
  'team_members.updated': 'עדכון תפקיד',
  'team_members.deleted': 'הסרת חבר צוות',

  // Client work (DB triggers)
  'projects.created': 'הפרויקט נוצר',
  'projects.updated': 'הפרויקט עודכן',
  'projects.deleted': 'הפרויקט נמחק',
  'tasks.created': 'משימה נוספה',
  'tasks.updated': 'משימה עודכנה',
  'tasks.deleted': 'משימה נמחקה',
  'project_invoices.created': 'חשבונית נרשמה',
  'project_invoices.updated': 'חשבונית עודכנה',
  'project_invoices.deleted': 'חשבונית נמחקה',
  'project_payments.created': 'תשלום נרשם',
  'project_payments.updated': 'תשלום עודכן',
  'project_payments.deleted': 'תשלום נמחק',
  'time_entries.created': 'שעות נרשמו',
  'time_entries.updated': 'רישום שעות עודכן',
  'companies.created': 'הלקוח נוצר',
  'companies.updated': 'פרטי הלקוח עודכנו',
};

export function labelFor(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? action;
}

/** Map entity_type to a Hebrew chip label. */
export const ENTITY_TYPE_LABELS: Record<string, string> = {
  organizations: 'ארגון',
  user_profiles: 'פרופיל',
  team_members: 'צוות',
  audit_log: 'יומן',
};

export function entityLabel(entityType: string | null): string | null {
  if (!entityType) return null;
  return ENTITY_TYPE_LABELS[entityType] ?? entityType;
}
